import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { color } from '../../../app/theme';
import RecurringMessagePreview from '../../shared/previews/RecurringMessagePreview';

const useStyles = makeStyles(
  () => ({
    root: () => ({
      position: 'fixed',
      top: `79px`,
      right: '0',
      display: 'flex',
      flexDirection: 'column',
      height: 'calc(100vh - 79px)',
      width: '368px',
      boxShadow: '0 4px 16px 0 rgba(0, 0, 0, 0.08)',
      backgroundColor: '#fcfcfc',
    }),
    header: {
      flex: '1 0 56px',
      display: 'flex',
      alignItems: 'center',
      height: 56,
      fontSize: 17,
      lineHeight: 1,
      color: color.$13,
      backgroundColor: color.$7,
      padding: '0 0 0 16px',
    },
    content: {
      flex: '1 1 100%',
      padding: '16px',
      overflowY: 'auto',
    },
  }),
  {
    name: 'Preview',
  },
);

function Preview({ elements = [] }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const { icon: orgIconURL } = useSelector(store => store.organization);

  return (
    <div className={classes.root}>
      <div className={classes.header}>{t('preview')}</div>
      <div className={classes.content}>
        <RecurringMessagePreview orgIconURL={orgIconURL} elements={elements} />
      </div>
    </div>
  );
}

export default Preview;
